import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateProductType } from '../../api/inventory';
import TransactionAmount, { ProductItem } from 'api/inventory-types';

const CreateProductType = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        name: '',
        points: '',
        type: 'permanent',
        deliveryMethod: 'virtual_product',
        isAmbassador: false,
        isPremium: false
    });
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const productItem = new ProductItem(
                formData.id, 
                formData.name, 
                new TransactionAmount(new Map([['points', parseInt(formData.points)]])), 
                formData.type, 
                formData.deliveryMethod,
                0, // numberInStock
                formData.isAmbassador,
                formData.isPremium
            );

            const response = await updateProductType(productItem);
            if (response.status === 200) {
                navigate('/admin/products');
            } else {
                setError('Failed to create product type');
            }
        } catch (err: any) {
            setError(err.message);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const target = e.target;
        const value = target.type === 'checkbox' ? (target as HTMLInputElement).checked : target.value;
        setFormData({
            ...formData,
            [target.name]: value
        });
    };

    return (
        <div className="max-w-2xl mx-auto py-8">
            <h2 className="text-2xl font-bold mb-6">Create New Product Type</h2>
            {error && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                    {error}
                </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Product ID
                    </label>
                    <input
                        type="text"
                        name="id"
                        required
                        value={formData.id}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        placeholder="unique_product_id"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Product Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        placeholder="Product Name"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Points Price
                    </label>
                    <input
                        type="number"
                        name="points"
                        required
                        value={formData.points}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        placeholder="100"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Product Type
                    </label>
                    <select
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                        <option value="consumable">Consumable</option>
                        <option value="permanent">Permanent</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Delivery Method
                    </label>
                    <select
                        name="deliveryMethod"
                        value={formData.deliveryMethod}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                        <option value="virtual_product">Virtual Product</option>
                        <option value="digital_product">Digital Product</option>
                        <option value="physical_product">Physical Product</option>
                    </select>
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        name="isAmbassador"
                        checked={formData.isAmbassador}
                        onChange={handleChange}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label className="ml-2 block text-sm font-medium text-gray-700">
                        Ambassador
                    </label>
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        name="isPremium"
                        checked={formData.isPremium}
                        onChange={handleChange}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label className="ml-2 block text-sm font-medium text-gray-700">
                        Premium
                    </label>
                </div>

                <div className="flex justify-end space-x-4">
                    <button
                        type="button"
                        onClick={() => navigate('/admin/products')}
                        className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                    >
                        Create Product Type
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CreateProductType; 